export default function (value: any): boolean {
  if (typeof value !== 'string') {
    return false
  }

  try {
    const url = new URL(value)

    return true
  } catch (err) {
    return false
  }
}
